require('../proposals/efficient-64-bit-arithmetic');
require('../proposals/string-at');
require('../proposals/url');
var parent = require('./1');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// /Volumes/Box/sites/wandsworthhub/app/bedrock/web/app/themes/wandsworthhub/node_modules/core-js/stage/0.js
// module id = 432
// module chunks = 0